import React, { useState } from 'react';
import './giveFeedback.css';
import axiosInstance from '../../axios';

const GiveFeedback = ({ onClose }) => {
  const [showPopUP, setShowPopUP] = useState(true);
  const [rating, setRating] = useState(4); // Default to 4 stars as shown in image
  const [feedback, setFeedback] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmitFeedback = e => {
    e.preventDefault();
    setIsLoading(true);
    axiosInstance
      .post(`/v1/feedback`, {
        userId: JSON.parse(localStorage.getItem('userDetails')).userId,
        user_type: 'STUDENT',
        rating,
        feedback,
      })
      .then(data => {
        if (data.data.is_success) {
          setRating(4);
          setFeedback('');
          setSubmitted(true);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleStarClick = starIndex => {
    setRating(starIndex + 1);
  };

  return (
    <>
      {/* <button onClick={() => setShowPopUP(true)}>Show PopUP</button> */}
      {showPopUP && (
        <div className="feedback-modal-overlay">
          <div className="feedback-modal">
            <button
              className="close-button"
              onClick={() => {
                setShowPopUP(false);
                onClose();
              }}>
              ×
            </button>
            {!submitted && (
              <div className="feedback-content">
                <h2 className="feedback-title">Share your experience</h2>

                <div className="star-rating">
                  {[...Array(5)].map((_, index) => (
                    <button
                      key={index}
                      type="button"
                      className={`star ${index < rating ? 'star-filled' : 'star-empty'}`}
                      onClick={() => handleStarClick(index)}>
                      ★
                    </button>
                  ))}
                </div>

                <p className="feedback-question">
                  Do you have any thoughts or suggestions you'd like to share?
                </p>

                <form onSubmit={handleSubmitFeedback}>
                  <textarea
                    className="feedback-textarea"
                    placeholder="Type here"
                    value={feedback}
                    onChange={e => setFeedback(e.target.value)}
                    rows="8"
                  />

                  <button type="submit" className="submit-button mt-2" disabled={isLoading}>
                    {isLoading ? 'Submitting...' : 'Submit'}
                  </button>
                </form>
              </div>
            )}
            {submitted && (
              <div className="feedback-content">
                <h2 className="feedback-title" style={{ marginBottom: '0px' }}>
                  Thank you for your feedback!
                </h2>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default GiveFeedback;
